import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Heart } from 'lucide-react';
import MainLogo from '../Logo/MainLogo';

const Footer = () => {
  const location = useLocation();

  return (
    <footer className="bg-[#F8F9FE] border-t border-slate-100 py-16 px-6 max-w-full min-w-[300px]">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8">
        <Link to="/" className="flex items-center  cursor-pointer">

          <MainLogo height={80} width={130} />


        </Link>
        <div className="flex flex-wrap justify-center gap-8 text-[11px] font-bold text-slate-400 uppercase tracking-widest">
          {/* <Link to="/blog" className={`transition-colors ${location.pathname === '/blog' ? 'text-[#5059E5]' : 'hover:text-[#5059E5]'}`}>Blog</Link> */}
          <Link to="/privacy" className="hover:text-[#5059E5] transition-colors">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-[#5059E5] transition-colors">Terms & Conditions</Link>
          <Link to="/contact" className="hover:text-[#5059E5] transition-colors">Contact Us</Link>
          <Link to="/about" className="hover:text-[#5059E5] transition-colors">About Us</Link>
        </div>
        <div className="text-xs font-bold text-slate-300 uppercase tracking-widest flex items-center gap-2">
          MADE WITH <Heart className="w-4 h-4 text-rose-500 fill-current" /> BY runmytools
        </div>
      </div>
    </footer>
  );
};

export default Footer;

